import type { FC } from 'react'

import type { TIconProps } from 'types'

const WishListIcon: FC<TIconProps> = ({ className }) => (
  <svg className={className} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.53475 2.59961L7.53581 2.59961C9.26404 2.59961 10.8376 3.23824 12.0001 4.3653C13.1626 3.23824 14.7362 2.59961 16.4644 2.59961H16.4654C18.186 2.60165 19.8262 3.32079 21.0287 4.58376C22.2298 5.84523 22.8982 7.54659 22.9001 9.31252C22.9001 12.9975 20.3254 16.1971 17.9265 18.4034C15.4959 20.639 13.0216 22.0598 12.7783 22.1953C12.5415 22.3284 12.2741 22.3996 12.0001 22.3996C11.7261 22.3996 11.4587 22.3284 11.2219 22.1953C10.9787 22.0598 8.50425 20.639 6.07365 18.4034C3.67484 16.1971 1.1001 12.9984 1.1001 9.31348C1.10199 7.54756 1.77038 5.84523 2.9715 4.58376C4.17404 3.32079 5.81415 2.60165 7.53475 2.59961Z'
      fill='#19191A'
    />
  </svg>
)

export default WishListIcon
